export const LOCAL_LOGIN_PATH = '/auth/login';
export const LOCAL_LOGOUT_PATH = '/auth/logout';

export const LOCAL_AUTH_PATHS = Object.freeze([
  LOCAL_LOGIN_PATH,
  LOCAL_LOGOUT_PATH,
  '/login',
  '/access-code',
  '/confirm-account',
  '/create-account',
  '/verify-email',
]);
